module.exports = __webpack_public_path__ + "static/media/Course Handbook 2024-25.6596be24.pdf";